import React from 'react';

export default ({ color }) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><g fill="#4a4f54"><path d="m4.5 9c0-3.33.91-6.23 2.25-7.79a3 3 0 0 0 -2.25-1.21c-2.5 0-4.5 4-4.5 9s2 9 4.5 9a3 3 0 0 0 2.25-1.21c-1.34-1.56-2.25-4.46-2.25-7.79z"/><ellipse cx="13.5" cy="9" rx="4.5" ry="9"/></g></svg>
);
